function PValue() {
  return (
    <div>
      <li className="bullet-item">p-value: reported p-value for strongest SNP risk allele</li>
    </div>
  );
}

export default PValue;
